import "@fontsource-variable/geist";
import "@fontsource/geist-mono";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/App";
import "@/app/globals.css";
import { logger, setupGlobalObservability } from "@/lib/logger";

const container = document.getElementById("root");

if (!container) {
  logger.error("Root container not found.");
  throw new Error("Root container not found.");
}

setupGlobalObservability();
logger.info("Mounting React application.");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
